/**
 * Timeline Zoom API Composable
 * Handles registration of zoom controls with parent component
 */

import { inject } from 'vue';

interface TimelineInstance {
    zoomIn: () => void;
    zoomOut: () => void;
    resetToFit: () => void;
}

export const useTimelineZoomAPI = (timelineInstance: TimelineInstance) => {
    const registerTimelineZoomAPI = inject<((api: {
        zoomIn: () => void;
        zoomOut: () => void;
        resetToFit: () => void;
    }) => void) | undefined>('registerTimelineZoomAPI');

    if (registerTimelineZoomAPI) {
        registerTimelineZoomAPI({
            zoomIn: timelineInstance.zoomIn,
            zoomOut: timelineInstance.zoomOut,
            resetToFit: timelineInstance.resetToFit
        });
    }
};
